import Alert from '@mui/material/Alert';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { useTranslation } from 'react-i18next';
import { getDealsLabels } from '../../../../../lib/DealForm/utils/dealFormUtils.ts';
import type { UseAgenciesOptionsFetch } from '../../../../../lib/utils/context/DealHookTypes.ts';

export interface AgencyRenderProps {
  useAgencyFetch: UseAgenciesOptionsFetch;
  agencySalesforceId: string | null | undefined;
}

export const AgencyRender = ({ useAgencyFetch, agencySalesforceId }: AgencyRenderProps) => {
  const { t } = useTranslation();
  const labels = getDealsLabels(t);
  const { mapById: agencyMap, loading: isLoading } = useAgencyFetch();

  const agencyName = agencySalesforceId ? (agencyMap[agencySalesforceId]?.name ?? agencySalesforceId) : null;

  const showWarning = !isLoading && agencySalesforceId && agencyMap[agencySalesforceId] === undefined;

  return (
    <>
      {showWarning && (
        <Alert severity="warning" sx={{ marginBottom: 1.5 }} data-test="agency-not-found">
          {t('The agency has been removed from Salesforce')}
        </Alert>
      )}

      <FieldDetails loading={isLoading} title={labels.agency_salesforce_id} value={agencyName} />
    </>
  );
};
